import dotPropImmutable from 'dot-prop-immutable';
import isEmpty from 'lodash/isEmpty';
export const dynamicTemplateSlice = {
    setDynamicConditions: (state, { payload })=>{
        const path = `data.${state.activeId}.dynamicConditions`;
        return dotPropImmutable.set(state, path, payload);
    },
    updateDynamicConditions: (state, { payload: { entityId, conditions } })=>{
        const path = `data.${state.activeId}.dynamicConditions.${entityId}`;
        if (isEmpty(conditions.criteria)) {
            return {
                ...state,
                ...dotPropImmutable.delete(state, path)
            };
        }
        return dotPropImmutable.set(state, path, conditions);
    }
};
